import { useEffect, useState } from 'react';

import { accessApi, oauthStartUrl, type LoginOptions } from '../services/api/client';

/**
 * Botões de login social (PRD 33.5) — Google/Microsoft, condicionados ao que
 * `/access/login-options` (público) devolver. São links de navegação de
 * página inteira, não fetch: o provedor precisa de um redirect real do
 * navegador para a tela de consentimento.
 *
 * `inviteToken`, quando presente, viaja para o backend e permite criar
 * conta nova (PRD 33.1) — sem ele, só entra em conta já existente.
 */
export function SocialLoginButtons({ inviteToken }: { inviteToken?: string }) {
  const [options, setOptions] = useState<LoginOptions | null>(null);

  useEffect(() => {
    accessApi
      .loginOptions()
      .then(setOptions)
      .catch(() => setOptions({ google: false, microsoft: false }));
  }, []);

  if (!options || (!options.google && !options.microsoft)) return null;

  return (
    <div className="social-login">
      <p className="muted small">ou</p>
      <div className="button-row">
        {options.google && (
          <a className="button-link" href={oauthStartUrl('google', inviteToken)}>
            Entrar com Google
          </a>
        )}
        {options.microsoft && (
          <a className="button-link" href={oauthStartUrl('microsoft', inviteToken)}>
            Entrar com Microsoft
          </a>
        )}
      </div>
    </div>
  );
}
